module.exports = __webpack_public_path__ + "img/Icon - Start Flag.cea6248b.svg";